import { useEffect } from "react";
import { MultiSelect } from "react-multi-select-component";
import { frontDB } from "../../../../frontDB";
import { usePurchaseOrders } from "../../usePurchaseOrders";
import styles from "./PurchaseOrdersHeader.module.css";
import { usePurchaseOrdersHeader } from "./usePurchaseOrdersHeader";
import { FiMenu } from "react-icons/fi";
import {
  Button,
  Input,
  InputPicker,
  DateRangePicker,
  InputGroup,
  IconButton,
  Dropdown,
  Popover,
  Whisper,
} from "rsuite";
import { status_types, requisition_types } from "../../../Settings/Data/lists";
import { capitalizeFirstLetter } from "../../../../helperFunctions";
import ExcelIcon from "./.../../../../../Components/Components/ComponentsHeader/xlsx.png";
import CloseIcon from "@rsuite/icons/Close";

function PurchaseOrdersHeader() {
  let { showCreatePurchaseOrder, purchaseOrdersArrayLength } =
    usePurchaseOrders();

  //let { locations, location } = frontDB();
  let locations = frontDB((state) => state.locations);
  let location = frontDB((state) => state.location);

  let {
    filter,
    locationHandler,
    searchInputHandler,
    periodFromHandler,
    periodToHandler,
    periodRangeHandler,
    setSelectedLocation,
    searchValues,
    selectedStatuses,
    handleStatusChange,
    selectedTypes,
    handleTypeChange,
    searchClearHandler,
    generatingRL,
    onExport,
  } = usePurchaseOrdersHeader();

  useEffect(() => {
    setSelectedLocation();
  }, [location]); //[location]

  let statusOptions = [
    ...status_types.map((item) => ({
      label: capitalizeFirstLetter(item),
      value: item.toLowerCase(),
    })),
  ];

  let typeOptions = [
    ...requisition_types.map((item) => ({ label: item, value: item })),
  ];

  let locationOptions = [
    { label: "All vessels", value: "*" },

    ...locations
      .filter((item) => item.status !== "inactive")
      .map((item) => ({ label: item.name, value: item._id })),
  ];

  const startOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        0,
        0,
        0,
        0,
      ),
    );
  };

  const endOfUTCDate = (date) => {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        23,
        59,
        59,
        999,
      ),
    );
  };

  const now = new Date();
  const tomorrow = new Date(now);
  const today = new Date(now);
  //tomorrow.setUTCDate(now.getUTCDate() + 1);
  const todayEnd = endOfUTCDate(today);
  const tomorrowEnd = endOfUTCDate(tomorrow);

  const start7Days = new Date(now);
  start7Days.setUTCDate(now.getUTCDate() - 7);

  const start14Days = new Date(now);
  start14Days.setUTCDate(now.getUTCDate() - 14);

  const start1Month = new Date(now);
  start1Month.setUTCMonth(now.getUTCMonth() - 1);

  const start3Month = new Date(now);
  start3Month.setUTCMonth(now.getUTCMonth() - 3);

  const start6Month = new Date(now);
  start6Month.setUTCMonth(now.getUTCMonth() - 6);

  const start12Month = new Date(now);
  start12Month.setUTCMonth(now.getUTCMonth() - 12);

  const start24Month = new Date(now);
  start24Month.setUTCMonth(now.getUTCMonth() - 24);

  const predefinedRanges = /** @type {any} */ ([
    {
      label: "7 days",
      value: [startOfUTCDate(start7Days), todayEnd],
      placement: "left",
    },
    {
      label: "14 days",
      value: [startOfUTCDate(start14Days), todayEnd],
      placement: "left",
    },
    {
      label: "1 month",
      value: [startOfUTCDate(start1Month), todayEnd],
      placement: "left",
    },
    {
      label: "3 month",
      value: [startOfUTCDate(start3Month), todayEnd],
      placement: "left",
    },
    {
      label: "6 month",
      value: [startOfUTCDate(start6Month), todayEnd],
      placement: "left",
    },
    {
      label: "12 month",
      value: [startOfUTCDate(start12Month), todayEnd],
      placement: "left",
    },
    {
      label: "24 month",
      value: [startOfUTCDate(start24Month), todayEnd],
      placement: "left",
    },
  ]);

  const tooltip = <Popover>Export Purchase Orders</Popover>;
  const generateExportButton = (
    <div
      onClick={() => {
        onExport(filter, purchaseOrdersArrayLength);
      }}
      style={{
        width: 35,
        height: 40,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        transition: "0.5s",
        backgroundColor: "transparent",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.3)")}
      onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
    >
      <Whisper
        delay={200}
        placement="top"
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <img
          src={ExcelIcon}
          alt="Export to Excel"
          style={{ width: "100%", height: "100%" }}
        />
      </Whisper>
    </div>
  );

  const exportMenu = (
    <div className={styles.export_menu_container}>
      <Dropdown
        placement="bottomEnd"
        renderToggle={(props, ref) => (
          <IconButton
            {...props}
            ref={ref}
            icon={<FiMenu style={{ height: 20, width: 30 }} />}
            appearance="subtle"
            style={{
              width: "auto",
              height: 35,
              marginLeft: 0,
              display: "flex",
              alignItems: "center",
              padding: "0 12px",
            }}
          >
            {/* <span
              style={{ marginTop: 1, marginLeft: 4, fontWeight: 500 }}
            ></span> */}
          </IconButton>
        )}
      >
        <Dropdown.Item
          onClick={() => {
            onExport(filter, purchaseOrdersArrayLength);
          }}
        >
          <div style={{ marginLeft: 15, width: 200 }}>
            Export Requisition list
          </div>
        </Dropdown.Item>
        <Dropdown.Item onClick={showCreatePurchaseOrder}>
          <div style={{ marginLeft: 15, width: 200 }}>
            Add New Requisition list
          </div>
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
  //! Render
  return (
    <>
      <div className={styles.purchaseOrders_header}>
        <div className={styles.purchaseOrders_header_title}>
          Requisitions lists
        </div>

        <div className={styles.purchaseOrders_header_options}>
          <InputPicker
            value={filter?.locationId}
            onChange={locationHandler}
            cleanable={false}
            placeholder="Select Vessel"
            data={locationOptions}
            style={{ width: 230 }}
          />

          <div className={styles.date_pickers_container}>
            <DateRangePicker
              isoWeek
              ranges={predefinedRanges}
              value={[new Date(filter.from), new Date(filter.to)]}
              onChange={periodRangeHandler}
              cleanable={false}
              format="dd/MM/yyyy"
              placeholder="Select period"
              style={{ width: 320 }}
            />
          </div>

          <MultiSelect
            className={styles.multi_select}
            hasSelectAll={true}
            disableSearch={true}
            options={statusOptions}
            value={selectedStatuses}
            onChange={handleStatusChange}
            labelledBy="Select status"
            ArrowRenderer={Arrow}
            overrideStrings={{ allItemsAreSelected: "All statuses" }}
          />

          <MultiSelect
            className={styles.multi_select}
            hasSelectAll={false}
            disableSearch={true}
            options={typeOptions}
            value={selectedTypes}
            onChange={handleTypeChange}
            labelledBy="Select type"
            ArrowRenderer={Arrow}
            overrideStrings={{
              selectSomeItems: "All types",
              allItemsAreSelected: "All types",
            }}
          />
          {exportMenu}
          {/* <Button
            onClick={showCreatePurchaseOrder}
            color="blue"
            appearance="primary"
            style={{ width: "200px" }}
          >
            Add New Requisition list
          </Button> */}
        </div>
      </div>
      <div className={styles.purchaseOrders_header_searchoptions}>
        <InputGroup inside style={{ width: "150px" }}>
          <Input
            value={searchValues?.requisitionNumber}
            className={styles.search_input}
            id="requisitionNumber"
            onChange={searchInputHandler}
            placeholder="Search by #"
          />
          {searchValues?.requisitionNumber && (
            <InputGroup.Button
              id="requisitionNumberButton"
              onClick={() => searchClearHandler("requisitionNumber")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <InputGroup inside style={{ width: "226px" }}>
          <Input
            value={searchValues?.title}
            className={styles.search_input}
            id="title"
            onChange={searchInputHandler}
            placeholder="Search by title"
          />
          {searchValues?.title && (
            <InputGroup.Button
              id="titleButton"
              onClick={() => searchClearHandler("title")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <InputGroup inside style={{ width: "148px" }}>
          <Input
            className={styles.search_input}
            value={searchValues?.itemsLocation}
            id="itemsLocation"
            onChange={searchInputHandler}
            placeholder="Search by port"
          />
          {searchValues?.itemsLocation && (
            <InputGroup.Button
              id="itemsLocationButton"
              onClick={() => searchClearHandler("itemsLocation")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        <InputGroup inside style={{ width: "149px" }}>
          <Input
            className={styles.search_input}
            value={searchValues?.vendor}
            id="vendor"
            onChange={searchInputHandler}
            placeholder="Search by vendor"
          />
          {searchValues?.vendor && (
            <InputGroup.Button
              id="vendorButton"
              onClick={() => searchClearHandler("vendor")}
            >
              <CloseIcon />
            </InputGroup.Button>
          )}
        </InputGroup>
        {/* <div
          style={{
            width: "630px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          {generateExportButton}
        </div> */}
      </div>
    </>
  );
}

export default PurchaseOrdersHeader;

const Arrow = () => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 21 32"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      aria-label="angle down"
      data-category="legacy"
      padding-left="30px"
    >
      <path d="M19.196 13.143a.612.612 0 01-.179.411l-8.321 8.321c-.107.107-.268.179-.411.179s-.304-.071-.411-.179l-8.321-8.321c-.107-.107-.179-.268-.179-.411s.071-.304.179-.411l.893-.893a.582.582 0 01.411-.179c.143 0 .304.071.411.179l7.018 7.018 7.018-7.018c.107-.107.268-.179.411-.179s.304.071.411.179l.893.893a.617.617 0 01.179.411z"></path>
    </svg>
  );
};
